import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  id: "menuButton",
  class: "btn btn-default dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-offset": "-250,1"
}
const _hoisted_3 = {
  class: "dropdown-menu",
  "aria-labelledby": "menuButton"
}
const _hoisted_4 = { class: "btn btn-default" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list me-2" }, null, -1)
const _hoisted_6 = { class: "btn btn-default" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list me-2" }, null, -1)
const _hoisted_8 = { class: "btn btn-default" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clone me-2" }, null, -1)
const _hoisted_10 = { class: "btn btn-default" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-qrcode me-2" }, null, -1)
const _hoisted_12 = { class: "btn btn-default" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-flickr me-2" }, null, -1)
const _hoisted_14 = { class: "btn btn-default" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-folder-open me-2" }, null, -1)
const _hoisted_16 = { class: "btn btn-default" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-qrcode me-2" }, null, -1)
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrows-alt me-2" }, null, -1)
const _hoisted_21 = { class: "btn btn-default" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-history me-2" }, null, -1)
const _hoisted_23 = { class: "dropdown-item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-2" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-2" }, null, -1)
const _hoisted_26 = { class: "dropdown-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload me-2" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload me-2" }, null, -1)

import { useRoute, useRouter } from "vue-router";
import { ContentsUrl } from "../../../utils/ContentsUrl";
import { SessionUser } from "../../../utils/SessionUser";
import { VrockFileHandler } from "../../../utils/VrockFileHandler";
import { blocklyStore } from "../../../blockly/blocklyStore";
import { DialogHandler } from "../../dialog/DialogHandler";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { Permission } from "../../../utils/Permission";
import { translation } from "../../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileMenuButtons',
  setup(__props) {

const t = translation;
const router = useRouter();
const route = useRoute();

// ルーティングとプロジェクトID
const project_id = route.params.project_id as string;
const user_id = SessionUser.instance.userId;

/**
 * タイトル・ラベル
 */
const contentsUrl = ContentsUrl.instance.getUrl(project_id, user_id);

const openBackup = () => {
  blocklyStore
    .save()
    .then((value) => {
      MessageDialog.info(value);
      router.push({ name: "RecoverBackupPage", params: { project_id: project_id } });
    })
    .catch((error) => {
      MessageDialog.systemError("保存", "リスト遷移時", error);
    });
};

const showArMarkerList = () => {
  DialogHandler.showArMarkerListDialog();
};

const showFlicker360Dialog = () => {
  DialogHandler.showFlickerDialog();
};

const showFileManagerDialog = async () => {
  const value = await blocklyStore.save();
  MessageDialog.info(value);
  router.push(`/files/${project_id}?page=user`,);
};

const click_list = () => {
  router.push("/list");
};

const click_class_member_list = () => {
  router.push("/class_list");
};

const openQr = () => {
  DialogHandler.showQRDialog();
};

/**
 * クライアントサイドのみでファイルのダウンロードを実施する
 * vrockfileのダウンロードで使っている
 * @param content
 * @param fileName
 */
function fileDownloadByClientside(content: any, fileName: string): void {
  const blob = new Blob([content], { type: "application/force-download" });
  const msSaveBlob = (window.navigator as any).msSaveBlob;
  if (msSaveBlob) {
    // console.log('window.navigator.msSaveBlob' + msSaveBlob);
    msSaveBlob(blob, fileName);
  } else {
    // console.log('Else window.navigator.msSaveBlob');
    // リンクに紐付けて強制発火
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("target", "_blank");
    link.setAttribute("download", fileName);
    link.click();
  }
}

const exportProject = async () => {
  //
  const handler = new VrockFileHandler();
  const fileName = handler.getFileName(blocklyStore.title, project_id);
  await blocklyStore.save();
  const xml_text = blocklyStore.workspaceToXML;
  const code = blocklyStore.js_code;

  const vrockString = handler.toVrockFileString(xml_text, code);
  fileDownloadByClientside(vrockString, fileName);
};

const importProject = () => {
  DialogHandler.showVrockFileUploadDialog();
};

const click_template = () => {
  DialogHandler.showTemplateDialog();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, _toDisplayString(_unref(t).to("ファイル", "file")), 1),
    _createElementVNode("ul", _hoisted_3, [
      (!_unref(SessionUser).instance.isClassRoomMember())
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "dropdown-item",
            onClick: click_list
          }, [
            _createElementVNode("button", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("作品リスト", "project_list")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(SessionUser).instance.isClassRoomMember())
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: "dropdown-item",
            onClick: click_class_member_list
          }, [
            _createElementVNode("button", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("クラスメンバー作品リスト", "class_member_project_list")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: click_template
      }, [
        _createElementVNode("button", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("テンプレート一覧", "template_list")), 1)
        ])
      ]),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: showArMarkerList
      }, [
        _createElementVNode("button", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("ARマーカーリスト", "ar_marker_list")), 1)
        ])
      ]),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: showFlicker360Dialog
      }, [
        _createElementVNode("button", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("Flickrで背景写真を見つける", "flickr360")), 1)
        ])
      ]),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: showFileManagerDialog
      }, [
        _createElementVNode("button", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("3Dモデル、画像、動画、音楽のファイル(マイアセット)", "file_manager")), 1)
        ])
      ]),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: openQr
      }, [
        _createElementVNode("button", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("QRコード", "qr_code")), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createElementVNode("a", {
          class: "btn btn-default",
          target: "_blank",
          href: _unref(contentsUrl)
        }, [
          _hoisted_20,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("別ページで開く", "open_another_tab")), 1)
        ], 8, _hoisted_19)
      ]),
      _createElementVNode("li", {
        class: "dropdown-item",
        onClick: openBackup
      }, [
        _createElementVNode("button", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", null, _toDisplayString(_unref(t).to("リカバリー", "recovery")), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_23, [
        (_unref(Permission).overStandard)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-default",
              onClick: exportProject
            }, [
              _hoisted_24,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("プロジェクトエクスポート", "project_export")), 1)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-secondary text-start w-100",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(Permission).notPermitted && _unref(Permission).notPermitted(...args)))
            }, [
              _hoisted_25,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("プロジェクトエクスポート", "project_export")), 1)
            ]))
      ]),
      _createElementVNode("li", _hoisted_26, [
        (_unref(Permission).overStandard)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-default",
              onClick: importProject
            }, [
              _hoisted_27,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("プロジェクトインポート", "project_import")), 1)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-secondary text-start w-100",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(Permission).notPermitted && _unref(Permission).notPermitted(...args)))
            }, [
              _hoisted_28,
              _createElementVNode("span", null, _toDisplayString(_unref(t).to("プロジェクトインポート", "project_import")), 1)
            ]))
      ])
    ])
  ]))
}
}

})